import React from 'react';

import { Plan } from '@api/types';
import { Feature } from '@react/Pages/AccountSettingsPage/PricingPlanPage/features';
import { PricingPlan } from '@react/Pages/AccountSettingsPage/PricingPlanPage/PricingPlan/PricingPlan';
import { isFlatPlan } from '@redux/ducks/account/pricingPlan/pricingPlans.utils';

import './PricingPlans.scss';

export interface PricingPlansProps {
  currentPlan?: Plan;
  isYearly: boolean;
  monthlyPaymentPlans: Plan[];
  features: Feature[];
  paymentPlans: Plan[];
  onConfirm: () => void;
  onCancel: () => void;
}

export const PricingPlans = ({
  currentPlan,
  isYearly,
  monthlyPaymentPlans,
  features,
  paymentPlans,
  onConfirm,
  onCancel,
}: PricingPlansProps) => {
  const showFlatPlan = isFlatPlan(currentPlan);
  const visiblePlans = paymentPlans.filter(plan => showFlatPlan || !isFlatPlan(plan));

  return (
    <div className="pricing-plans">
      {visiblePlans.map(plan => (
        <PricingPlan
          key={plan.id}
          onConfirm={onConfirm}
          onCancel={onCancel}
          plan={plan}
          currentPlan={currentPlan}
          isYearly={isYearly}
          monthlyPaymentPlans={monthlyPaymentPlans}
          features={features}
        />
      ))}
    </div>
  );
};
